export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_371.79f11794.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};